import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { User } from '../../types';
import { Briefcase, Users, Heart, Target, Lightbulb, Sparkles, GraduationCap } from 'lucide-react';

interface AboutSectionProps {
  person: User;
}

export function AboutSection({ person }: AboutSectionProps) {
  const sections = [
    {
      icon: Briefcase,
      title: 'Professional Description',
      value: person.professionalDescription,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      icon: Target,
      title: 'Professional Habit',
      value: person.professionalHabit,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
    {
      icon: Users,
      title: 'Known For (Friend Group)',
      value: person.friendGroupKnownFor,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      icon: Heart,
      title: 'Hobbies',
      value: person.hobbies,
      color: 'text-pink-600',
      bgColor: 'bg-pink-50',
    },
    {
      icon: Lightbulb,
      title: 'Life Goal',
      value: person.lifeGoal,
      color: 'text-amber-600',
      bgColor: 'bg-amber-50',
    },
    {
      icon: Sparkles,
      title: 'Fun Fact',
      value: person.funFact,
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-50',
    },
    {
      icon: GraduationCap,
      title: 'Career Learning Goals',
      value: person.careerLearning,
      color: 'text-teal-600',
      bgColor: 'bg-teal-50',
    },
  ];

  const hasAnyData = sections.some(section => section.value);

  if (!hasAnyData) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>About</CardTitle>
          <CardDescription>
            This person hasn't completed their onboarding profile yet.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {sections.map((section, index) => {
        if (!section.value) return null;
        
        const Icon = section.icon;
        
        return (
          <Card key={index}>
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg ${section.bgColor}`}>
                  <Icon className={`h-5 w-5 ${section.color}`} />
                </div>
                <CardTitle className="text-lg">{section.title}</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground leading-relaxed">{section.value}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
